module.exports = __webpack_public_path__ + "static/media/nz.02951cfc.webp";